import Environment from '@interfaces/environment.interface'
import onEnvironmentChange from '@observables/environment.observable'
import MainService from '@services/main/main.service'
import { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'
import LogService from '../log/log.service'

export default class ZeCariocaService extends MainService {
  url: string
  logService = new LogService()

  constructor(zeCariocaUrl?: string) {
    super()
    if (!zeCariocaUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.zeCarioca
      })
    } else {
      this.url = zeCariocaUrl
    }
    this.logService.init('ZeCarioca Service')
  }

  async postNFByTransactionId(id, file, serialNumber, emissionDate, value, datafile = null) {
    const formData = new window.FormData()
    const url = `${this.url}/nf`
    const headers = await this.getHeaders()
    headers['Content-Type'] = 'multipart/form-data'
    formData.append('transactionId', id)
    formData.append('file', file)
    if (datafile) {
      formData.append('datafile', datafile)
    }
    formData.append('serialNumber', serialNumber)
    formData.append('emissionDate', emissionDate)
    formData.append('value', value)

    return this.http
      .post(url, formData, {
        headers: headers,
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({ message: 'Failed to send invoice', error })
        throw error.response
      })
  }

  public async postImportedNfe(transactionId: string, nfId: string) {
    const headers = await this.getHeaders()
    return this.http
      .post(
        `${this.url}/nf-imported`,
        {
          transactionId: transactionId,
          nfId: nfId,
        },
        { headers }
      )
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on save nfe imported',
          error,
        })
        throw error.response
      })
  }
}
